import { useEffect } from "react"
import { AUTH_BRAND } from "utils/authPlatform"
import wuloojMark from "assets/images/superadmin/wulooj-mark.png"

/**
 * Favicon + page title + theme-color while on a platform-branded auth route.
 * @param {boolean} enabled
 * @param {string} title — full document title or segment before `| ${AUTH_BRAND}`
 */
export default function usePlatformAuthChrome(enabled, title) {
  useEffect(() => {
    if (!enabled) return undefined

    const link =
      document.querySelector("link[rel='icon']") ||
      Object.assign(document.createElement("link"), { rel: "icon" })
    if (!link.parentNode) document.head.appendChild(link)

    const prevHref = link.getAttribute("href") || ""
    const prevTitle = document.title
    link.href = wuloojMark
    document.title = title.includes("|")
      ? title
      : `${title} | ${AUTH_BRAND}`

    const metaTheme = document.querySelector("meta[name='theme-color']")
    const prevTheme = metaTheme?.getAttribute("content")
    if (metaTheme) metaTheme.setAttribute("content", "#AA90D3")

    return () => {
      if (prevHref) link.setAttribute("href", prevHref)
      document.title = prevTitle
      if (metaTheme && prevTheme !== undefined) {
        metaTheme.setAttribute("content", prevTheme || "#000000")
      }
    }
  }, [enabled, title])
}
